const message = {
    btnLoadMore: "Cargar más",
    goBack: "Volver atrás",

};
export default message;